module.exports = __webpack_public_path__ + "static/img/servicesbg7.a14c61b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/servicesbg7.jpg
// module id = p4Qy
// module chunks = 1